import { render, staticRenderFns } from "./AspectRatioHorizontalIcon.vue?vue&type=template&id=0b8c9bec&scoped=true"
import script from "./AspectRatioHorizontalIcon.vue?vue&type=script&lang=js"
export * from "./AspectRatioHorizontalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8c9bec",
  null
  
)

export default component.exports